import React, { useState } from 'react';

function ConfigPage() {
  const [step, setStep] = useState(1);
  const [showSql, setShowSql] = useState(false);

  const sqlScript = `-- 房间表
CREATE TABLE rooms (
  id UUID DEFAULT gen_random_uuid() PRIMARY KEY,
  room_key VARCHAR(50) UNIQUE NOT NULL,
  room_name VARCHAR(100) NOT NULL,
  max_players INTEGER DEFAULT 6,
  current_players INTEGER DEFAULT 0,
  status VARCHAR(20) DEFAULT 'waiting',
  host_id UUID,
  created_at TIMESTAMP WITH TIME ZONE DEFAULT NOW(),
  updated_at TIMESTAMP WITH TIME ZONE DEFAULT NOW()
);

-- 玩家表
CREATE TABLE players (
  id UUID DEFAULT gen_random_uuid() PRIMARY KEY,
  room_id UUID REFERENCES rooms(id) ON DELETE CASCADE,
  player_name VARCHAR(50) NOT NULL,
  chips INTEGER DEFAULT 1000,
  seat_position INTEGER,
  is_host BOOLEAN DEFAULT FALSE,
  is_active BOOLEAN DEFAULT TRUE,
  last_action VARCHAR(20),
  joined_at TIMESTAMP WITH TIME ZONE DEFAULT NOW(),
  updated_at TIMESTAMP WITH TIME ZONE DEFAULT NOW()
);

-- 游戏记录表
CREATE TABLE game_sessions (
  id UUID DEFAULT gen_random_uuid() PRIMARY KEY,
  room_id UUID REFERENCES rooms(id) ON DELETE CASCADE,
  session_number INTEGER DEFAULT 1,
  pot_amount INTEGER DEFAULT 0,
  current_bet INTEGER DEFAULT 0,
  current_player_id UUID REFERENCES players(id),
  game_stage VARCHAR(20) DEFAULT 'preflop',
  community_cards TEXT[],
  status VARCHAR(20) DEFAULT 'active',
  winner_id UUID REFERENCES players(id),
  created_at TIMESTAMP WITH TIME ZONE DEFAULT NOW(),
  updated_at TIMESTAMP WITH TIME ZONE DEFAULT NOW()
);

-- 行动记录表
CREATE TABLE game_actions (
  id UUID DEFAULT gen_random_uuid() PRIMARY KEY,
  game_session_id UUID REFERENCES game_sessions(id) ON DELETE CASCADE,
  player_id UUID REFERENCES players(id),
  action_type VARCHAR(20) NOT NULL,
  bet_amount INTEGER DEFAULT 0,
  chips_after INTEGER,
  created_at TIMESTAMP WITH TIME ZONE DEFAULT NOW()
);

-- 启用实时更新
ALTER TABLE rooms ENABLE ROW LEVEL SECURITY;
ALTER TABLE players ENABLE ROW LEVEL SECURITY;
ALTER TABLE game_sessions ENABLE ROW LEVEL SECURITY;
ALTER TABLE game_actions ENABLE ROW LEVEL SECURITY;

-- 创建策略（内部使用，策略较宽松）
CREATE POLICY "Enable all for rooms" ON rooms FOR ALL USING (true);
CREATE POLICY "Enable all for players" ON players FOR ALL USING (true);
CREATE POLICY "Enable all for game_sessions" ON game_sessions FOR ALL USING (true);
CREATE POLICY "Enable all for game_actions" ON game_actions FOR ALL USING (true);`;

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      alert('已复制到剪贴板！');
    });
  };

  const steps = [
    {
      title: '1. 注册 Supabase 账号',
      content: (
        <div>
          <p>前往 <a href="https://supabase.com" target="_blank" rel="noopener noreferrer" style={{color: '#3b82f6'}}>supabase.com</a> 注册账号</p>
          <p>使用 GitHub 账号登录最为方便</p>
        </div>
      )
    },
    {
      title: '2. 创建新项目',
      content: (
        <div>
          <p>• 点击 "New Project" 创建新项目</p>
          <p>• 选择组织（个人账号）</p>
          <p>• 项目名称：<code>dx-poker</code></p>
          <p>• 设置数据库密码（请记住！）</p>
          <p>• 选择地区（建议选择亚洲）</p>
          <p>• 点击 "Create new project"</p>
        </div>
      )
    },
    {
      title: '3. 获取项目配置',
      content: (
        <div>
          <p>项目创建完成后：</p>
          <p>• 点击左侧菜单 "Settings" → "API"</p>
          <p>• 复制 "Project URL"</p>
          <p>• 复制 "anon public" 密钥</p>
          <div style={{background: '#fef3c7', padding: '10px', borderRadius: '8px', marginTop: '10px'}}>
            <strong>⚠️ 注意：</strong> 不要复制 "service_role" 密钥！
          </div>
        </div>
      )
    },
    {
      title: '4. 创建数据库表',
      content: (
        <div>
          <p>• 点击左侧菜单 "SQL Editor"</p>
          <p>• 点击 "New query"</p>
          <p>• 复制下面的 SQL 脚本并执行</p>
          <button 
            onClick={() => setShowSql(!showSql)} 
            className="btn btn-primary"
            style={{marginTop: '10px'}}
          >
            {showSql ? '隐藏' : '显示'} SQL 脚本
          </button>
          {showSql && (
            <div style={{marginTop: '15px'}}>
              <div style={{
                background: '#1f2937',
                border: '1px solid #374151',
                borderRadius: '8px',
                padding: '15px',
                fontSize: '12px',
                fontFamily: 'monospace',
                overflow: 'auto',
                maxHeight: '300px'
              }}>
                <pre style={{margin: 0, whiteSpace: 'pre-wrap'}}>{sqlScript}</pre>
              </div>
              <button 
                onClick={() => copyToClipboard(sqlScript)}
                className="btn btn-secondary"
                style={{marginTop: '10px'}}
              >
                复制 SQL 脚本
              </button>
            </div>
          )}
        </div>
      )
    },
    {
      title: '5. 设置环境变量',
      content: (
        <div>
          <p>在项目根目录创建 <code>.env</code> 文件：</p>
          <div style={{
            background: '#1f2937',
            border: '1px solid #374151',
            borderRadius: '8px',
            padding: '15px',
            fontSize: '14px',
            fontFamily: 'monospace',
            marginTop: '10px'
          }}>
            <div>REACT_APP_SUPABASE_URL=你的_supabase_url</div>
            <div>REACT_APP_SUPABASE_ANON_KEY=你的_supabase_anon_key</div>
          </div>
          <button 
            onClick={() => copyToClipboard('REACT_APP_SUPABASE_URL=你的_supabase_url\nREACT_APP_SUPABASE_ANON_KEY=你的_supabase_anon_key')}
            className="btn btn-secondary"
            style={{marginTop: '10px'}}
          >
            复制环境变量模板
          </button>
          <div style={{background: '#fef3c7', padding: '10px', borderRadius: '8px', marginTop: '10px'}}>
            <strong>⚠️ 重要：</strong> 替换 "你的_supabase_url" 和 "你的_supabase_anon_key" 为实际值！
          </div>
        </div>
      )
    },
    {
      title: '6. 重启应用',
      content: (
        <div>
          <p>• 保存 .env 文件</p>
          <p>• 在终端中停止应用 (Ctrl+C)</p>
          <p>• 重新启动： <code>npm start</code></p>
          <p>• 刷新浏览器页面</p>
          <div style={{background: '#d1fae5', padding: '10px', borderRadius: '8px', marginTop: '10px'}}>
            <strong>🎉 完成！</strong> 配置完成后，您将看到登录页面。
          </div>
        </div>
      )
    }
  ];

  return (
    <div className="container">
      <div className="card">
        <h1 className="page-title">🔧 配置 Supabase</h1>
        
        <div style={{marginBottom: '20px'}}>
          <div style={{
            background: '#fef3c7',
            padding: '15px',
            borderRadius: '8px',
            marginBottom: '20px'
          }}>
            <h3 style={{color: '#92400e', margin: 0}}>需要先配置 Supabase 数据库</h3>
            <p style={{margin: '5px 0 0 0', color: '#92400e'}}>
              请按照以下步骤完成配置，大约需要 5-10 分钟
            </p>
          </div>
        </div>

        {/* 步骤指示器 */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '30px',
          overflowX: 'auto'
        }}>
          {steps.map((_, index) => (
            <div
              key={index}
              style={{
                width: '30px',
                height: '30px',
                borderRadius: '50%',
                background: step > index ? '#10b981' : step === index + 1 ? '#3b82f6' : '#6b7280',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '14px',
                fontWeight: 'bold',
                cursor: 'pointer'
              }}
              onClick={() => setStep(index + 1)}
            >
              {index + 1}
            </div>
          ))}
        </div>

        {/* 当前步骤内容 */}
        <div className="card">
          <h3 style={{color: '#3b82f6', marginBottom: '15px'}}>
            {steps[step - 1].title}
          </h3>
          <div style={{lineHeight: '1.6'}}>
            {steps[step - 1].content}
          </div>
        </div>

        {/* 导航按钮 */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: '20px'
        }}>
          <button
            onClick={() => setStep(Math.max(1, step - 1))}
            disabled={step === 1}
            className="btn btn-secondary"
          >
            上一步
          </button>
          <button
            onClick={() => setStep(Math.min(steps.length, step + 1))}
            disabled={step === steps.length}
            className="btn btn-primary"
          >
            下一步
          </button>
        </div>

        {/* 帮助信息 */}
        <div style={{
          marginTop: '30px',
          padding: '15px',
          background: 'rgba(59, 130, 246, 0.1)',
          borderRadius: '8px',
          fontSize: '14px'
        }}>
          <h4 style={{color: '#3b82f6', marginBottom: '10px'}}>需要帮助？</h4>
          <p style={{margin: 0}}>
            如果遇到问题，请查看浏览器控制台的错误信息，或者检查：
          </p>
          <ul style={{margin: '5px 0 0 20px'}}>
            <li>Supabase 项目是否已创建完成</li>
            <li>数据库表是否已创建</li>
            <li>环境变量是否正确设置</li>
            <li>是否已重启应用</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ConfigPage; 